module.exports = __webpack_public_path__ + "static/media/PM109.44b00352.png";